import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { TraceClassDecorator } from '@sentry/angular';
import { SelectItem } from 'primeng';
import { ApiResult, PromiseResult, ServerError } from 'src/app/models/PromiseResult';
import { PatientService } from 'src/app/services/patient.service';
import { RefferalDiscountService } from 'src/app/services/refferal-discount.service';
import { BreadcrumbService } from '../shared/breadcrumb.service';
import { ProviderStateService } from 'src/app/services/provider-state.service';

class CustmonCode {
    index: number;
    discount_code: string;
    discount_id: string;
    discount_percent: string;
    referral_type: string;
}
@Component({
    selector: 'app-coupon-list',
    templateUrl: './coupon-list.component.html',
    styleUrls: ['./coupon-list.component.css']
})
@TraceClassDecorator()
export class CouponListComponent implements OnInit {
    member_api_result: ApiResult = new ApiResult(false);
    coupon_api_result: ApiResult = new ApiResult(false);
    DiscountCodeList: CustmonCode[];
    selectedMember: any;
    slug: string = "";
    // posting: boolean;
    // response: PromiseResult;
    // serverError: ServerError;
    members_list: SelectItem[] = [];
    constructor(
        private readonly referral: RefferalDiscountService,
        private readonly patientservice: PatientService,
        private readonly breadcrumbService: BreadcrumbService,
        private readonly providerstateService: ProviderStateService
    ) {
       
        // this.posting = false;
    }

    async ngOnInit() {
        this.slug= this.providerstateService.getProviderSlug();
        this.breadcrumbService.setItems([
            { label: 'Dashboard', routerLink:['/', this.slug, 'patient']},
            { label: 'Discount Codes' }
        ]);
        await this.getMemberList();
    }
    private ResetResultModels(): void {
        // this.response = {
        //     success: null,
        //     error: null,
        //     data: null
        // };
        // this.serverError = {
        //     statusCode: null,
        //     error: null,
        //     message: null
        // };
    }
    async getMemberList() {
        this.ResetResultModels();
        this.member_api_result.Posting = true;
        await this.patientservice
            .getMember(sessionStorage.getItem('userid'))
            .toPromise()
            .then((result) => {
                this.member_api_result.PromiseResult = result;
                if (result.success) {
                    this.members_list = result.data.patient.map(m => {
                        return {
                            label: m.first_name +
                                ' ' +
                                (m.middle_name==null?'':m.middle_name) +
                                ' ' +
                                m.last_name,
                            value: m.patient_guid
                        }
                    });
                }
            })
            .catch((error: HttpErrorResponse) => {
                this.member_api_result.ServerError = error.error;
                this.member_api_result.PromiseResult.success = false;
            });
        this.member_api_result.Posting = false;
    }

    async getDiscountList(patient_guid: string) {
        
        this.coupon_api_result.Posting = true;
        this.DiscountCodeList = [];
        this.ResetResultModels();
        await this.referral
            .getPatientApplicableDiscountCopounList(patient_guid)
            .toPromise()
            .then((resp) => {
                this.coupon_api_result.PromiseResult = resp;
                if (resp.success) {
                    let i = 0;
                    this.DiscountCodeList = resp.data.discounts.map(code => {
                        const coupon = new CustmonCode();
                        coupon.index = i++;
                        coupon.discount_id = code.discount_id;
                        coupon.discount_code = code.discount_code;
                        coupon.discount_percent = code.discount_percent;
                        coupon.referral_type = code.egd_referral_master_type.referral_type;
                        return coupon;
                    });
                }
            })
            .catch((error: HttpErrorResponse) => {
                this.coupon_api_result.ServerError = error.error;
                this.coupon_api_result.PromiseResult.success = false;
            });
        this.coupon_api_result.Posting = false;
    }
}
